import T from 'prop-types';
import React from 'react';
import { Column, Grid } from '@acast/decibel';
import DescriptionField from '../fields/description';
import PositionField from '../fields/position';
import ThumbnailField from '../fields/thumbnail';
import TypeField from '../fields/type';
import { markerPropType } from '../../../../../../customPropTypes';

const ImageForm = ({ episodeDuration, marker, markers, onUpdateMarker }) => (
  <Grid>
    <Column>
      <ThumbnailField marker={marker} onChange={onUpdateMarker('image')} />
    </Column>
    <Column width="50%">
      <TypeField value={marker.type} onChange={onUpdateMarker('type')} />
    </Column>
    <Column width="50%">
      <PositionField
        marker={marker}
        markers={markers}
        episodeDuration={episodeDuration}
        onChange={onUpdateMarker('start')}
      />
    </Column>
    <Column>
      <DescriptionField value={marker.description} onChange={onUpdateMarker('description')} />
    </Column>
  </Grid>
);

ImageForm.propTypes = {
  episodeDuration: T.number.isRequired,
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType).isRequired,
  onUpdateMarker: T.func.isRequired,
};

export default ImageForm;
